import React, { useEffect, useState, useRef } from 'react';
import {
    DialogTitle, DialogContent, DialogActions, Dialog, makeStyles, Paper, ClickAwayListener, MenuList, MenuItem, Card, CardContent, Divider,
    Popper,
    Grow,
} from '@material-ui/core';
import { Document, Page, pdfjs } from 'react-pdf';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getRequestTimeInMillis, getTripStartDateFilterValues, getTripDateFilterValues } from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({

    filterButton: {
        backgroundColor: "#fff",
        // margin: "0 3px",
        borderRadius: 30,
        textTransform: "capitalize",
        padding: "5px 10px",
        fontWeight: 300
    },
    arrowDropDownIconV1: {
        marginTop: -3
    },
    menuItemV1: {
        display: 'flex', justifyContent: 'flex-start', fontWeight: 300, paddingTop: 10, paddingBottom: 10, textTransform: 'capitalize'
    },
    spanV1: {
        marginLeft: 16,
        color: 'grey'
    },
    filterButtonVehicle: {
        textTransform: "capitalize",
        padding: "5px 10px",
        backgroundColor: "#fff",
        fontWeight: 300,
        paddingLeft: 16,
        borderRadius: 4
    },
    filterButtonRounded: {
        textTransform: "capitalize",
        padding: "5px 10px",
        backgroundColor: "#fff",
        fontWeight: 300,
        paddingLeft: 16,
        borderRadius: 30
    },
    wV1: {
        width: '100%'
    },
    expandMoreIcon: {
        marginTop: -1,
        color: 'grey'
    }
}));

const DateFilter = ({ dateValue, deafultValue, fromReportsDialog, fromReportsSideBar, fromSingleVehicle, fromSinglePartyTripsTab, fromSinglePartyPaymentTab, fromSingleSupplierTripsTab, vehicle, fromTripListing, roundedBorder }) => {
    const [selectedPDFFilterDate, setSelectedPDFFilterDate] = useState(deafultValue ? deafultValue : "ALL_MONTHS");
    const [selectedDateFilterValueSingleVehicle, setSelectedDateFilterValueSingleVehicle] = useState("ALL_MONTHS");

    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const prevOpen = useRef(open);

    var dateFilterValues = getTripStartDateFilterValues();

    var dateFilterValuesSingleVehicle = getTripDateFilterValues();

    const classes = useStyles();

    useEffect(() => {
        if (vehicle.defaultDateFilterValue) {
            setSelectedDateFilterValueSingleVehicle(vehicle.defaultDateFilterValue);
        }
    }, [vehicle.defaultDateFilterValue]);

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, []);

    const handleFilterOpen = () => {
        setOpen(true)
    }

    const handleCloseFilter = () => {
        setOpen(false);
    }

    const handleItemClick = (value) => {
        dateValue(value);
        setSelectedDateFilterValueSingleVehicle(value)
        setSelectedPDFFilterDate(value);
        handleCloseFilter();
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    }


    return (
        <>
            {(fromReportsDialog || fromReportsSideBar) &&
                <Button
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    variant="outlined"
                    size="small"
                    className={classes.filterButton}
                    onClick={handleFilterOpen}
                >
                    {dateFilterValues[selectedPDFFilterDate]["value"]}{" "}
                    <ArrowDropDownIcon className={classes.arrowDropDownIconV1} />
                </Button>
            }

            {(fromSinglePartyTripsTab || fromSinglePartyPaymentTab || fromSingleSupplierTripsTab || fromTripListing) &&
                <Button
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    variant="outlined"
                    size="small"
                    className={roundedBorder ? classes.filterButtonRounded : classes.filterButtonVehicle}
                    onClick={handleFilterOpen}
                >
                    {dateFilterValues[selectedPDFFilterDate]["value"]}{" "}
                    <ArrowDropDownIcon className={classes.arrowDropDownIconV1} />
                </Button>
            }

            {fromSingleVehicle &&
                <Button
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    variant="outlined"
                    size="small"
                    className={classes.filterButtonVehicle}
                    onClick={handleFilterOpen}
                >
                    {dateFilterValuesSingleVehicle[selectedDateFilterValueSingleVehicle]["value"]}{" "}
                    <ExpandMoreIcon className={classes.expandMoreIcon} />
                </Button>
            }

            {
                open &&
                <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1000 }}>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList autoFocusItem={open} id="menu-list-grow">

                                        {/* Date Filter for reports. */}
                                        {(fromReportsDialog || fromSinglePartyTripsTab || fromSingleSupplierTripsTab || fromTripListing || fromReportsSideBar) && Object.keys(dateFilterValues).map((value, index) => (
                                            <div className={classes.wV1}>
                                                {/* {dateFilterValues[value]["value"] !== "Custom" && */}
                                                < div className={classes.wV1} >
                                                    < MenuItem key={index} className={classes.menuItemV1} onClick={() => handleItemClick(value)}><span>{dateFilterValues[value]["value"]}</span></MenuItem>
                                                    <Divider light />
                                                </ div>
                                                {/* } */}
                                            </div>
                                        ))}

                                        {/* Date Filter for Single Vehicle. */}
                                        {(fromSingleVehicle || fromSinglePartyPaymentTab) && Object.keys(dateFilterValuesSingleVehicle).map((value, index) => (
                                            <div className={classes.wV1}>
                                                {/* {dateFilterValuesSingleVehicle[value]["value"] !== "Custom" && */}
                                                < div className={classes.wV1} >
                                                    < MenuItem key={index} className={classes.menuItemV1} onClick={() => handleItemClick(value)}><span>{dateFilterValuesSingleVehicle[value]["value"]}</span></MenuItem>
                                                    <Divider light />
                                                </ div>
                                                {/* } */}
                                            </div>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            }
        </>
    );
}

const mapStateToProps = (state) => ({
    vehicle: state.vehicle
});
export default connect(mapStateToProps)(DateFilter);
